import React, { useState, useEffect } from 'react';
import './DTCProductBuilder.less';
import { Switch, Route, Redirect } from 'react-router-dom';
import DTCProductTable from 'components/DTCProductTable/DTCProductTable';
import { Select } from 'antd';
import * as api from 'util/api.js';
import STORES from 'config/stores';
import { getCountryFromIP } from 'util/geolocation';
import DTCProductBuilderFormContent from './DTCProductBuilderFormContent/DTCProductBuilderFormContent';
import NewDTCProductBuilder from './NewDTCProductBuilder';
import { generateShopifyProductPayload } from './utils/generateShopifyProductPayload';

const DTCProductBuilder = () => {
  const [prices, setPrices] = useState([]);
  const [pricingRules, setPricingRules] = useState(null);
  const [store, setStore] = useState(STORES.GPNZ);

  const [defaultStore, setDefaultStore] = useState();
  useEffect(async () => {
    const country = await getCountryFromIP();
    setDefaultStore(country.code === 'AU' ? STORES.GPAU : STORES.GPNZ);
  }, []);

  const { Option } = Select;

  const fetchPrices = () => {
    api.getDtcPricing().then((data) => {
      setPrices(data);
    }).catch((error) => {
      console.error('Failed to fetch pricing data', error);
    });
  };

  useEffect(() => {
    fetchPrices();
    api.listPricingRules().then(setPricingRules).catch((error) => {
      console.error('Failed to fetch pricing rules', error);
    });
  }, []);

  const [generatorStatus, setGeneratorStatus] = useState({
    active: false,
    error: null,
    success: false,
  });

  const StoreButton = () => (
    <Select
      className="generator-store-button"
      defaultValue={defaultStore}
      style={{ width: 180 }}
      value={store}
      onChange={(newStore) => {
        setStore(STORES[newStore]);
      }}
    >
      <Option value={STORES.GPNZ}>Garage Project NZ</Option>
      <Option value={STORES.GPAU}>Garage Project AU</Option>
    </Select>
  );

  const handleProductGeneration = async ({ type, data, dtcPrices }) => {
    const { formData, product } = data;
    try {
      setGeneratorStatus({
        active: true,
        error: null,
        success: null,
      });
      const shopifyProduct = generateShopifyProductPayload({
        store,
        product,
        formData: {
          ...formData,
        },
        dtcPrices,
        rules: pricingRules,
      });
      await api.createNewShopifyProduct(store, shopifyProduct, {
        productMatrixId: product?.id,
      });
      setGeneratorStatus({
        active: false,
        error: null,
        success: true,
      });
    } catch (error) {
      setGeneratorStatus({
        active: false,
        error: error.response?.data.error.userError ?? 'There was an error generating the product',
        success: false,
      });
    } finally {
      setGeneratorStatus((prev) => ({ ...prev, active: false }));
    }
  };

  return (
    <Switch>
      <Route
        exact
        path="/dashboard/dtc-product-builder/new"
        render={() => (
          <NewDTCProductBuilder prices={prices} rules={pricingRules} />
        )}
      />
      {[
        {
          type: 'shopify',
        },
        {
          type: 'kounta',
        },
      ].map(({ type }) => (
        <Route
          key={type}
          exact
          path={`/dashboard/dtc-product-builder/${type}`}
          render={() => (
            <DTCProductTable
              store={store}
              StoreButton={StoreButton}
              prices={prices}
              type={type}
              generatorStatus={generatorStatus}
              selectionType="single"
              pluralLabel={`${type} labels`}
              GeneratorFormContent={DTCProductBuilderFormContent}
              onGenerate={(data) => handleProductGeneration({ type, data, dtcPrices: prices })}
            />
          )}
        />
      ))}
      <Redirect to="/dashboard/dtc-product-builder/new" />
    </Switch>
  );
};

export default DTCProductBuilder;
